import { CardWithIcon } from '../../Design/Cards'

import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import CircularProgress from '@mui/material/CircularProgress'

const WeeklyLeads = ({ value, loading }) => (
  <div>
    <CardWithIcon
      to="/leads"
      icon={PeopleAltIcon}
      title="Nouveaux contacts"
      subtitle={loading ? <CircularProgress size="15px" /> : value === 10000 ? '+10 000' : value}
      color="#83c4c1"
    />
  </div>
)

export default WeeklyLeads